import type { MouseEvent } from "react";
import { FC, memo } from "react";

import { useOrganizationContext } from "../../contexts/organizations/organizationsContext";
import { useCheckAccess } from "../../hooks/useCheckAccess";
import { ConfirmModal } from "../CustomModal/ConfirmModal";

export interface IProps {
  isProcessing: boolean;
  isError: boolean;
  itemsCount?: number;
  onCancel: () => void;
  onSubmit: (e: MouseEvent<HTMLButtonElement>) => void;
}

const DeleteCacheItemPopup: React.FC<IProps> = memo(
  ({ isProcessing, isError, itemsCount, onCancel, onSubmit }) => {
    const { currentOrganization } = useOrganizationContext();
    const noSubscriptionError = `Deleting cache items is disabled while there is no active subscription for the ${currentOrganization?.name} organization.`;

    const { displayError } = useCheckAccess(noSubscriptionError, isError);
    const isMultipleItems = itemsCount && itemsCount > 1;
    return (
      <ConfirmModal
        visible={true}
        onCancel={onCancel}
        onSubmit={onSubmit}
        title={
          isMultipleItems
            ? `Delete ${itemsCount} cache item(s)`
            : "Delete cache item"
        }
        text={
          isMultipleItems
            ? "The cache item(s) will be deleted permanently and this action cannot be undone."
            : "The cache item will be deleted permanently and this action cannot be undone. Are you sure you want to delete the cache item?"
        }
        okText="Delete"
        isProcessing={isProcessing}
        displayError={displayError}
      />
    );
  },
);

export { DeleteCacheItemPopup };
